import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { SxProps } from '@mui/system/styleFunctionSx';
import { PageTransition } from 'components/PageTransition';

type Props = {
  children?: React.ReactNode;
  header?: React.ReactNode;
  backgroundColor?: string;
  childrenStyles?: SxProps;
};

// PageTransition lives here so every Layout-based page gets the same slide on navigation
// (and reduced-motion / suppress handling) — rather than each page opting in by hand, which
// left drill-in pages animating inconsistently.
export const Layout = ({
  children,
  header,
  backgroundColor = '#fafafa',
  childrenStyles
}: Props) => (
  <PageTransition>
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      {header && header}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor,
          pb: 4
        }}
      >
        <Container sx={{ pt: 2, pb: 5, ...childrenStyles }}>
          {children}
        </Container>
      </Box>
    </Box>
  </PageTransition>
);
